import _defineProperty from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import * as Yup from 'yup';
import HTTPMethod from 'http-method-enum';
import { Formik, Form } from 'formik';
import styled from 'styled-components';
import { AddressType } from '@yoweb/types/enums';
import { useTranslation, Trans } from '@yoweb/next-i18next';
import { Box } from '@yoweb/ui/components/Box';
import { Button } from '@yoweb/ui/components/buttons';
import { Grid } from '@yoweb/ui/components/Grid';
import { Link } from '@yoweb/ui/components/Link';
import { Text, Title } from '@yoweb/ui/components/typography';
import { postalCodeOnChangeHandler, validatePostalCode } from '@yoweb/utils/postalCode';
import { Checkbox, ErrorDisplay, Input, useError } from '@yoweb/ui/components/form';
import { API_VALIDATE_ZIP_CODE, API_WAITLIST_CUSTOMER, PAGE_PRIVACY_POLICY, PAGE_TERMS_OF_SERVICE, PAGE_INTRODUCTION_PANASONIC_YOHANA } from '@store/constants/routes';
import { fetchJson } from '@yoweb/utils/fetchJson';
import { useIntlMeta } from '@yoweb/ui/hooks/useIntlMeta';
import { usePersistedQueryParameters } from '@store/hooks/usePersistedQueryParameters';
import NameGrid from '@yoweb/ui/components/NameGrid';
import useReCaptcha from '@store/hooks/useReCaptcha';
import { ACTION_WAITLIST_SIGNUP } from '@store/constants/recaptcha';
import hasFullWidthChars from '@yoweb/utils/intl/hasFullWidthChars';
import { getSpace } from '@yoweb/ui/styles/utils/theme';
import { useExternalConfig } from '@store/contexts/ExternalConfig';
import { AsyncModal } from '@yoweb/ui/components/Modal/AsyncModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var MODAL_MAX_WIDTH = 656;
export var ModalStep;
/**
 * Modal which branches between purchase flow and waitlist sign-up
 * Orchestrates the various internal modal states of this flow
 */

(function (ModalStep) {
  ModalStep[ModalStep["POSTAL_CODE"] = 0] = "POSTAL_CODE";
  ModalStep[ModalStep["WAITLIST_SIGNUP"] = 1] = "WAITLIST_SIGNUP";
  ModalStep[ModalStep["WAITLIST_SUCCESS"] = 2] = "WAITLIST_SUCCESS";
  ModalStep[ModalStep["REDIRECT"] = 3] = "REDIRECT";
})(ModalStep || (ModalStep = {}));

var DirectToPurchaseModal = function DirectToPurchaseModal(_ref) {
  var isOpen = _ref.isOpen,
      onClose = _ref.onClose,
      isWaitlistEnabled = _ref.isWaitlistEnabled,
      _ref$initialStep = _ref.initialStep,
      initialStep = _ref$initialStep === void 0 ? ModalStep.POSTAL_CODE : _ref$initialStep,
      initialPostalCode = _ref.initialPostalCode;

  var _useState = useState(initialStep),
      step = _useState[0],
      setStep = _useState[1];

  var _useState2 = useState(initialPostalCode !== null && initialPostalCode !== void 0 ? initialPostalCode : ''),
      postalCode = _useState2[0],
      setPostalCode = _useState2[1];

  var _useState3 = useState(false),
      isServiceableArea = _useState3[0],
      setIsServiceableArea = _useState3[1];

  var completePostalCodeStep = function completePostalCodeStep(code, areaServiceable) {
    setStep(ModalStep.WAITLIST_SIGNUP);
    setPostalCode(code);
    setIsServiceableArea(areaServiceable);
  };

  var goToPostalCodeStep = function goToPostalCodeStep() {
    setStep(ModalStep.POSTAL_CODE);
  };

  var goToJpRedirectStep = function goToJpRedirectStep() {
    setStep(ModalStep.REDIRECT);
  };

  var completeWaitlistStep = function completeWaitlistStep() {
    setStep(ModalStep.WAITLIST_SUCCESS);
  };

  var onCloseModal = function onCloseModal() {
    onClose();
    setStep(ModalStep.POSTAL_CODE);
  };

  switch (step) {
    case ModalStep.POSTAL_CODE:
      return /*#__PURE__*/_jsx(PostalCodeStep, {
        isOpen: isOpen,
        onClose: onCloseModal,
        onComplete: completePostalCodeStep,
        goToJpRedirectStep: goToJpRedirectStep,
        isWaitlistEnabled: isWaitlistEnabled
      });

    case ModalStep.WAITLIST_SIGNUP:
      return /*#__PURE__*/_jsx(WaitlistStep, {
        isOpen: isOpen,
        onClose: onCloseModal,
        onComplete: completeWaitlistStep,
        postalCode: postalCode,
        isServiceableArea: isServiceableArea
      });

    case ModalStep.WAITLIST_SUCCESS:
      return /*#__PURE__*/_jsx(WaitlistSuccessStep, {
        isOpen: isOpen,
        onClose: onCloseModal,
        onComplete: onCloseModal,
        isServiceableArea: isServiceableArea
      });

    case ModalStep.REDIRECT:
      return /*#__PURE__*/_jsx(RedirectStep, {
        isOpen: isOpen,
        onClose: onCloseModal,
        goToPostalCodeStep: goToPostalCodeStep
      });

    default:
      return null;
  }
};

/**
 * Collects the users postal code.
 */
var PostalCodeStep = function PostalCodeStep(_ref2) {
  var isOpen = _ref2.isOpen,
      onClose = _ref2.onClose,
      onComplete = _ref2.onComplete,
      goToJpRedirectStep = _ref2.goToJpRedirectStep,
      isWaitlistEnabled = _ref2.isWaitlistEnabled;

  var _useTranslation = useTranslation(['common']),
      t = _useTranslation.t;

  var _useIntlMeta = useIntlMeta(),
      country = _useIntlMeta.country;

  var router = useRouter();
  var errorDisplay = useError();

  var isPostalCodeJpLike = function isPostalCodeJpLike(postalCode) {
    return /^[0-9]{3}-?[0-9]{4}$/.test(postalCode);
  };

  useEffect(function () {
    var handleRouteChange = function handleRouteChange() {
      onClose();
    };

    router.events.on('routeChangeComplete', handleRouteChange);
    return function () {
      router.events.off('routeChangeComplete', handleRouteChange);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router.events]);
  var postalValidationSchema = Yup.object({
    postalCode: Yup.string().required(t('common:validation.required')).test({
      message: t('common:validation.zip-code'),
      test: function test(value) {
        if (value) {
          // don't validate if FF is enabled and postal code looks like JP
          if (country === 'US' && isPostalCodeJpLike(value)) {
            return true;
          }

          return validatePostalCode(country, value);
        }

        return false;
      }
    })
  });

  var validateZipCode = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(values, actions) {
      var postalCode, checkoutPlanPathJP, data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              postalCode = values.postalCode;

              if (!(country === 'US' && isPostalCodeJpLike(postalCode))) {
                _context.next = 4;
                break;
              }

              goToJpRedirectStep();
              return _context.abrupt("return");

            case 4:
              checkoutPlanPathJP = PAGE_INTRODUCTION_PANASONIC_YOHANA;
              errorDisplay.clear();
              _context.prev = 6;
              _context.next = 9;
              return fetchJson(API_VALIDATE_ZIP_CODE, {
                method: HTTPMethod.POST,
                body: JSON.stringify({
                  postalCode: postalCode,
                  addressType: AddressType.ADDRESS_TYPE_SERVICE,
                  inviteCode: ''
                })
              });

            case 9:
              data = _context.sent;

              // If a user is in Japan and they're in a serviceable area and there is capacity (waitlist enabled flag is OFF),
              // send user to direct to purchase flow
              // Else if users is in US OR (the user is Japanese but their area isn't serviceable yet OR there's no capacity (waitlist enabled flag is ON)),
              // send user to the next step of waitlist sign up
              if (country === 'JP' && data.isAreaServiceable && !isWaitlistEnabled) {
                void router.push(checkoutPlanPathJP);
              } else {
                onComplete(postalCode, data.isAreaServiceable);
              }

              _context.next = 17;
              break;

            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](6);
              errorDisplay.set();
              throw _context.t0;

            case 17:
              _context.prev = 17;
              actions.setSubmitting(false);
              return _context.finish(17);

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[6, 13, 17, 20]]);
    }));

    return function validateZipCode(_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/_jsx(Formik, {
    initialValues: {
      postalCode: ''
    },
    validationSchema: postalValidationSchema,
    onSubmit: validateZipCode,
    children: function children(_ref4) {
      var isSubmitting = _ref4.isSubmitting,
          handleSubmit = _ref4.handleSubmit;
      return /*#__PURE__*/_jsx(AsyncModal, {
        maxWidth: MODAL_MAX_WIDTH,
        hasCloseButton: true,
        isOpen: isOpen,
        onClose: onClose,
        "data-testid": "direct-to-purchase-modal-postal",
        "data-gaid": "PurchaseZipCodeForm",
        actionButtons: /*#__PURE__*/_jsx(Button, {
          "data-testid": "zcm-btn-submit",
          isLoading: isSubmitting,
          onClick: function onClick() {
            return handleSubmit();
          },
          text: t('common:submit'),
          size: "lg",
          isDisabled: isSubmitting
        }),
        children: /*#__PURE__*/_jsxs(Box, {
          maxWidth: 392,
          mx: "auto",
          children: [(errorDisplay === null || errorDisplay === void 0 ? void 0 : errorDisplay.message) && /*#__PURE__*/_jsx(Box, {
            mb: "normal1",
            children: /*#__PURE__*/_jsx(ErrorDisplay, _objectSpread(_objectSpread({
              "data-testid": "postal-code-validation-error",
              withBorder: true
            }, errorDisplay), {}, {
              scrollTo: true
            }))
          }), /*#__PURE__*/_jsx(Title, {
            size: {
              _: 'md',
              md: 'xl'
            },
            textAlign: "center",
            children: t('common:join-now-modal.zipcode-step.where-located')
          }), /*#__PURE__*/_jsx(Box, {
            mt: "normal1",
            children: /*#__PURE__*/_jsx(Text, {
              size: "xl",
              textAlign: "center",
              children: t('common:join-now-modal.zipcode-step.available-select-cities-only')
            })
          }), /*#__PURE__*/_jsx(Box, {
            mt: "normal2",
            children: /*#__PURE__*/_jsx(Form, {
              children: /*#__PURE__*/_jsx(Input, {
                "data-testid": "zcm-input-postalcode",
                enforceCharacterWidth: "half",
                id: "postalCode",
                inputMode: "numeric",
                isRequired: true,
                label: t('common:join-now-modal.zipcode-step.zip-code'),
                name: "postalCode",
                onChange: function onChange(ev) {
                  return country === 'JP' && postalCodeOnChangeHandler(ev, country);
                }
              })
            })
          })]
        })
      });
    }
  });
};

/**
 * Waitlist form signup
 */
var WaitlistStep = function WaitlistStep(_ref5) {
  var _ref6, _ref7, _router$query, _utmParameters$utm_so, _utmParameters$utm_ca, _utmParameters$utm_me, _utmParameters$utm_te, _utmParameters$utm_co;

  var isOpen = _ref5.isOpen,
      onClose = _ref5.onClose,
      onComplete = _ref5.onComplete,
      postalCode = _ref5.postalCode,
      isServiceableArea = _ref5.isServiceableArea;

  var _useTranslation2 = useTranslation(['common']),
      t = _useTranslation2.t;

  var errorDisplay = useError();
  var reCaptcha = useReCaptcha();
  var router = useRouter();

  var _usePersistedQueryPar = usePersistedQueryParameters(),
      getPersistedParameter = _usePersistedQueryPar.getPersistedParameter;

  var _useIntlMeta2 = useIntlMeta(),
      country = _useIntlMeta2.country,
      localeHasFullWidthChars = _useIntlMeta2.localeHasFullWidthChars,
      lcLocale = _useIntlMeta2.lcLocale;

  var referralCode = (_ref6 = (_ref7 = getPersistedParameter('referralCode')) !== null && _ref7 !== void 0 ? _ref7 : router === null || router === void 0 ? void 0 : (_router$query = router.query) === null || _router$query === void 0 ? void 0 : _router$query.referralCode) !== null && _ref6 !== void 0 ? _ref6 : '';
  var utmParameters = getPersistedParameter('utm_params');
  var userAttribution = utmParameters ? {
    utmSource: (_utmParameters$utm_so = utmParameters['utm_source']) !== null && _utmParameters$utm_so !== void 0 ? _utmParameters$utm_so : '',
    utmCampaign: (_utmParameters$utm_ca = utmParameters['utm_campaign']) !== null && _utmParameters$utm_ca !== void 0 ? _utmParameters$utm_ca : '',
    utmMedium: (_utmParameters$utm_me = utmParameters['utm_medium']) !== null && _utmParameters$utm_me !== void 0 ? _utmParameters$utm_me : '',
    utmTerm: (_utmParameters$utm_te = utmParameters['utm_term']) !== null && _utmParameters$utm_te !== void 0 ? _utmParameters$utm_te : '',
    utmContent: (_utmParameters$utm_co = utmParameters['utm_content']) !== null && _utmParameters$utm_co !== void 0 ? _utmParameters$utm_co : ''
  } : undefined;
  var waitlistSchema = Yup.object().shape({
    firstName: Yup.string().trim().required(t('common:validation.required')),
    lastName: Yup.string().trim().required(t('common:validation.required')),
    email: Yup.string().email(t('common:validation.invalid-email')).trim().test({
      message: t('common:validation.enter-half-width-characters'),
      test: function test(value) {
        return value && localeHasFullWidthChars ? !hasFullWidthChars(value) : true;
      }
    }).required(t('common:validation.required')),
    referralCode: Yup.string()
  });

  var submitWaitlistForm = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(values, actions) {
      var reCaptchaToken, data;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              errorDisplay.clear();
              _context2.prev = 1;
              _context2.next = 4;
              return reCaptcha.execute(ACTION_WAITLIST_SIGNUP);

            case 4:
              reCaptchaToken = _context2.sent;
              _context2.next = 7;
              return fetchJson(API_WAITLIST_CUSTOMER, {
                method: HTTPMethod.POST,
                body: JSON.stringify({
                  referralCode: values.referralCode.trim(),
                  name: {
                    firstName: values.firstName.trim(),
                    lastName: values.lastName.trim()
                  },
                  emailAddress: {
                    address: values.email.trim()
                  },
                  postalCode: postalCode,
                  userAttribution: userAttribution,
                  reCaptchaToken: reCaptchaToken,
                  locale: lcLocale
                })
              });

            case 7:
              data = _context2.sent;

              if (data.inviteCode) {
                onComplete();
              }

              _context2.next = 15;
              break;

            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](1);
              errorDisplay.set();
              throw _context2.t0;

            case 15:
              _context2.prev = 15;
              actions.setSubmitting(false);
              return _context2.finish(15);

            case 18:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 11, 15, 18]]);
    }));

    return function submitWaitlistForm(_x3, _x4) {
      return _ref8.apply(this, arguments);
    };
  }();

  var waitlistDescription = '';

  if (!isServiceableArea) {
    waitlistDescription = t('common:join-now-modal.waitlist-signup-step.not-in-area');
  } else {
    waitlistDescription = t('common:join-now-modal.waitlist-signup-step.at-capacity');
  }

  return /*#__PURE__*/_jsx(Formik, {
    initialValues: {
      email: '',
      firstName: '',
      lastName: '',
      referralCode: referralCode,
      toggleTosPreference: true
    },
    onSubmit: submitWaitlistForm,
    validationSchema: waitlistSchema,
    validateOnMount: country === 'JP',
    children: function children(_ref9) {
      var values = _ref9.values,
          isValid = _ref9.isValid,
          isSubmitting = _ref9.isSubmitting,
          handleSubmit = _ref9.handleSubmit;
      return /*#__PURE__*/_jsx(AsyncModal, {
        maxWidth: MODAL_MAX_WIDTH,
        hasCloseButton: true,
        isOpen: isOpen,
        noPaddingBottom: true,
        onClose: onClose,
        "data-testid": "direct-to-purchase-modal-waitlist",
        "data-gaid": "PurchaseWaitListForm",
        actionButtons: /*#__PURE__*/_jsx(Button, {
          "data-testid": "wsm-btn-submit",
          isLoading: isSubmitting,
          onClick: function onClick() {
            return handleSubmit();
          },
          text: t('common:submit'),
          size: "lg",
          isDisabled: country === 'JP' ? !isValid || !values.toggleTosPreference : false
        }),
        children: /*#__PURE__*/_jsxs(Box, {
          maxWidth: 520,
          mx: "auto",
          children: [(errorDisplay === null || errorDisplay === void 0 ? void 0 : errorDisplay.message) && /*#__PURE__*/_jsx(Box, {
            mb: "normal1",
            children: /*#__PURE__*/_jsx(ErrorDisplay, _objectSpread(_objectSpread({
              "data-testid": "create-waitlist-user-error",
              withBorder: true
            }, errorDisplay), {}, {
              scrollTo: true
            }))
          }), /*#__PURE__*/_jsxs(Box, {
            display: "grid",
            alignContent: "space-between",
            "data-testid": "wsm-content",
            children: [/*#__PURE__*/_jsx(Title, {
              as: "h3",
              size: {
                _: 'md',
                md: 'xl'
              },
              textAlign: "center",
              children: t('common:join-now-modal.waitlist-signup-step.good-things-wait')
            }), /*#__PURE__*/_jsx(Box, {
              mt: "normal1",
              children: /*#__PURE__*/_jsx(Text, {
                as: "p",
                size: {
                  _: 'lg',
                  md: 'xl'
                },
                textAlign: "center",
                children: waitlistDescription
              })
            }), /*#__PURE__*/_jsx(Box, {
              mt: "normal1",
              children: /*#__PURE__*/_jsx(Form, {
                children: /*#__PURE__*/_jsxs(Box, {
                  display: "grid",
                  py: "normal2",
                  rowGap: "normal1",
                  children: [/*#__PURE__*/_jsxs(NameGrid, {
                    children: [/*#__PURE__*/_jsx(Input, {
                      id: "firstName",
                      name: "firstName",
                      "data-testid": "wsm-firstName",
                      maxLength: 40,
                      label: t('common:join-now-modal.waitlist-signup-step.personal.first-name')
                    }), /*#__PURE__*/_jsx(Input, {
                      id: "lastName",
                      name: "lastName",
                      "data-testid": "wsm-lastName",
                      maxLength: 80,
                      label: t('common:join-now-modal.waitlist-signup-step.personal.last-name')
                    })]
                  }), /*#__PURE__*/_jsx(Input, {
                    id: "email",
                    name: "email",
                    type: "email",
                    "data-testid": "wsm-email",
                    maxLength: 80,
                    label: t('common:join-now-modal.waitlist-signup-step.personal.email')
                  }), /*#__PURE__*/_jsx(Input, {
                    id: "referralCode",
                    name: "referralCode",
                    "data-testid": "wsm-referralCode",
                    maxLength: 60,
                    label: t('common:join-now-modal.waitlist-signup-step.personal.referral-code')
                  }), country === 'JP' ? /*#__PURE__*/_jsxs(Box, {
                    display: "grid",
                    py: "normal2",
                    rowGap: "small3",
                    children: [/*#__PURE__*/_jsx(Checkbox, {
                      "data-testid": "chk-tos-pref",
                      id: "toggleTosPreference",
                      name: "toggleTosPreference",
                      children: /*#__PURE__*/_jsx(Text, {
                        as: "span",
                        size: 'md',
                        children: /*#__PURE__*/_jsx(Trans, {
                          t: t,
                          i18nKey: "common:jp-opt-in-consent.tos",
                          components: [/*#__PURE__*/_jsx(Link, {
                            href: PAGE_TERMS_OF_SERVICE,
                            shouldOpenInTab: true,
                            hasUnderline: true
                          }, "0"), /*#__PURE__*/_jsx(Link, {
                            href: PAGE_PRIVACY_POLICY,
                            shouldOpenInTab: true,
                            hasUnderline: true
                          }, "1")]
                        })
                      })
                    }), /*#__PURE__*/_jsx(JpConsentDescription, {
                      size: "sm",
                      children: t('common:jp-opt-in-consent.note-waitlist')
                    })]
                  }) : /*#__PURE__*/_jsx(Text, {
                    size: {
                      _: 'sm',
                      md: 'sm'
                    },
                    textAlign: "center",
                    children: /*#__PURE__*/_jsx(Trans, {
                      t: t,
                      i18nKey: "common:join-now-modal.waitlist-signup-step.privacy-policy",
                      components: [/*#__PURE__*/_jsx(Text, {
                        href: PAGE_TERMS_OF_SERVICE,
                        as: "a",
                        size: {
                          _: 'md',
                          md: 'sm'
                        },
                        textDecoration: "underline",
                        target: "_blank",
                        rel: "noreferrer"
                      }, 0), /*#__PURE__*/_jsx(Text, {
                        href: PAGE_PRIVACY_POLICY,
                        as: "a",
                        size: {
                          _: 'md',
                          md: 'sm'
                        },
                        textDecoration: "underline",
                        target: "_blank",
                        rel: "noreferrer"
                      }, 1)],
                      values: {
                        email: t('common:support-email')
                      }
                    })
                  })]
                })
              })
            })]
          })]
        })
      });
    }
  });
};

/**
 * Shown after successfull signup to the waitlist.
 */
var WaitlistSuccessStep = function WaitlistSuccessStep(_ref10) {
  var isOpen = _ref10.isOpen,
      onClose = _ref10.onClose,
      onComplete = _ref10.onComplete,
      isServiceableArea = _ref10.isServiceableArea;

  var _useTranslation3 = useTranslation(['common']),
      t = _useTranslation3.t;

  var thankYouDescription = !isServiceableArea ? t('common:join-now-modal.waitlist-signup-success-step.non-serviceable-message') : t('common:join-now-modal.waitlist-signup-success-step.at-capacity-message');
  return /*#__PURE__*/_jsx(AsyncModal, {
    maxWidth: MODAL_MAX_WIDTH,
    hasCloseButton: true,
    isOpen: isOpen,
    noPaddingBottom: true,
    onClose: onClose,
    "data-testid": "direct-to-purchase-modal-success",
    "data-gaid": "PurchaseSuccessForm",
    actionButtons: /*#__PURE__*/_jsx(Button, {
      "data-testid": "wsmty-btn-close",
      size: "lg",
      onClick: onComplete,
      text: t('common:close')
    }),
    children: /*#__PURE__*/_jsxs(Box, {
      mb: "large3",
      mx: "auto",
      maxWidth: 392,
      "data-testid": "wsmty-content",
      children: [/*#__PURE__*/_jsx(Title, {
        as: "h3",
        size: {
          _: 'md',
          md: 'xl'
        },
        textAlign: "center",
        children: t('common:join-now-modal.waitlist-signup-success-step.thank-you')
      }), /*#__PURE__*/_jsx(Box, {
        mt: "normal2",
        children: /*#__PURE__*/_jsx(Text, {
          size: {
            _: 'md',
            md: 'xl'
          },
          textAlign: "center",
          children: thankYouDescription
        })
      })]
    })
  });
};

/**
 * Shown if zip code looks like Japanese postal code
 */
var RedirectStep = function RedirectStep(_ref11) {
  var isOpen = _ref11.isOpen,
      onClose = _ref11.onClose,
      goToPostalCodeStep = _ref11.goToPostalCodeStep;

  var _useTranslation4 = useTranslation(['common']),
      t = _useTranslation4.t;

  var _useExternalConfig = useExternalConfig(),
      baseJpUrl = _useExternalConfig.baseJpUrl;

  return /*#__PURE__*/_jsx(AsyncModal, {
    maxWidth: MODAL_MAX_WIDTH,
    hasCloseButton: true,
    isOpen: isOpen,
    noPaddingBottom: true,
    onClose: onClose,
    "data-testid": "direct-to-purchase-modal-redirect",
    actionButtons: /*#__PURE__*/_jsxs(Grid, {
      columns: {
        _: '1fr',
        md: 'max-content max-content'
      },
      gap: "small4",
      justify: "flex-end",
      children: [/*#__PURE__*/_jsx(Button, {
        "data-testid": "zcm-btn-no-thanks",
        onClick: function onClick() {
          goToPostalCodeStep();
        },
        text: t('common:join-now-modal.redirect-step.no-thanks'),
        variant: "secondary"
      }), /*#__PURE__*/_jsx(Button, {
        "data-testid": "zcm-lets-go",
        onClick: function onClick() {
          window.location.replace(baseJpUrl);
        },
        text: t('common:join-now-modal.redirect-step.lets-go'),
        type: "submit"
      })]
    }),
    children: /*#__PURE__*/_jsx(Box, {
      height: "100%",
      mt: "large1",
      mb: "large3",
      mx: {
        _: 'normal1',
        md: 'medium2'
      },
      children: /*#__PURE__*/_jsxs(Grid, {
        gap: "normal2",
        children: [/*#__PURE__*/_jsx(Title, {
          "data-testid": "zcm-title",
          as: "h1",
          size: {
            _: 'lg',
            md: 'xl'
          },
          textAlign: "center",
          children: t('common:join-now-modal.redirect-step.title')
        }), /*#__PURE__*/_jsx(Text, {
          "data-testid": "zcm-description",
          as: "p",
          size: {
            _: 'xl',
            md: 'lg'
          },
          textAlign: "center",
          children: t('common:join-now-modal.redirect-step.description')
        })]
      })
    })
  });
};

export default DirectToPurchaseModal;
var JpConsentDescription = styled(Text).withConfig({
  componentId: "sc-1vh70pe-0"
})(["padding-left:", ";"], getSpace('normal3'));